import { DataApiInputParams } from 'src/types/api';
import { Builder, appendFormData, getHeaders, getQueryString } from './utils';
import { IS_ENCRYPTION_ENABLED } from 'src/config';

export default (builder: Builder) => {
  return {
    getIcons: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `fw/icons?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Icon']
    }),
    uploadIcon: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        let formData = arg.params;
        let url = `fw/icons`;
        return fetchWithBQ({
          url: url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData),
          responseHandler: IS_ENCRYPTION_ENABLED ? 'text' : 'json'
        });
      },
      invalidatesTags: ['Icon']
    }),
    deleteIcon: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let formData = appendFormData(arg.params);
        let url = `fw/icons`;
        return fetchWithBQ({
          url: url,
          method: 'DELETE',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Icon']
    })
  };
};
